module.exports = __webpack_public_path__ + "img/small-10.48a0a3df.webp";